import type { CustomizationRegion, ShellControl } from '@1js/suiteux-shell-react';
import { SUITE_HEADER_BUTTONS_REGION_ID } from 'owa-header-constants';

export default function createHeaderButtonsRegion(
    customHeaderButtons: ShellControl[],
    setNotificationPaneContainer: (container: HTMLDivElement) => void
): CustomizationRegion {
    return {
        // OneOutlookSuiteHeader marks this region as no-drag so custom Suite Header
        // buttons remain clickable inside the native draggable title bar.
        regionID: SUITE_HEADER_BUTTONS_REGION_ID,
        flex: '0 0 auto',
        justifyContent: 'flex-end',
        alignItems: 'center',
        children: [
            ...customHeaderButtons,
            {
                id: 'OwaMergedNotificationPane',
                render: setNotificationPaneContainer,
            } as ShellControl,
        ],
    };
}
